import React from 'react';
import { PartnerLogos } from '@hpstellar/core';

import { getPartnerLogoContent } from '../../utility/setHtml';

import './partner-logos-enhanced.less';

export default function PartnerLogosEnhanced({ logos, footer }) {
    if (!logos || logos?.length < 1) {
        return null;
    }
    return (
        <PartnerLogos
            className={footer ? 'footer-logo-container' : 'header-partner-logo'}
            logos={getPartnerLogoContent(logos)}
        />
    );
}
